module.exports = __webpack_public_path__ + "static/img/insights-icon.ad94779a.gif";